import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener
} from '@angular/core';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'ui-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent {
  // { value: '', image: '', label: '' }
  @Input() options: any[];
  @Input() current: any;
  @Output() selected: EventEmitter<any> = new EventEmitter();

  downIcon = faCaretDown;
  showDropdown: boolean;

  isFocusInsideComponent = false;
  isComponentClicked = false;

  @HostListener('click')
  clickInside() {
    this.toggleDropdown();
    this.isFocusInsideComponent = true;
    this.isComponentClicked = true;
  }

  @HostListener('document:click')
  clickout() {
    if (!this.isFocusInsideComponent && this.isComponentClicked) {
      // clicked outside of this component
      this.hideDropdown();
      this.isComponentClicked = false;
    }
    this.isFocusInsideComponent = false;
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  hideDropdown() {
    this.showDropdown = false;
  }

  optionClicked(event) {
    this.selected.emit(event.value);
  }
}
